import { ref, watch } from "vue";


export default {
  __name: 'index',
  props: {
  name: {
    type: String,
    required: true,
  },
  initialQuantity: {
    type: Number,
    required: false,
    default: 1,
  },
  min: {
    type: Number,
    required: false,
    default: 1,
  },
  max: {
    type: Number,
    required: false,
    default: 999
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  helpText: {
    type: String,
    required: false,
  },
  helpClass: {
    type: String,
    required: false,
  },
},
  emits: ["update:quantity"],
  setup(__props, { emit }) {

const props = __props;




const val = ref(props.initialQuantity);

function add() {
  if (!props.disabled && (!props.max || (props.max && val.value < props.max))) {
    val.value++;
    emit("update:quantity", val.value);
  }
}

function subtract() {
  if (!props.disabled && val.value > props.min) {
    val.value--;
    emit("update:quantity", val.value);
  }
}

watch(
  () => props.initialQuantity,
  (newVal, oldVal) => {
    val.value = newVal;
  }
);

return { __sfc: true,props, emit, val, add, subtract }
}

}